import { Confirmation } from 'primeng/api';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

import { EventEmitter, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Competitor } from '../models/competitor';
import { City } from '../models/race';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  closeRegistrationDialog: EventEmitter<any> = new EventEmitter();
  confirmEvent: EventEmitter<Confirmation> = new EventEmitter();
  pdfFullScreenEvent: EventEmitter<string> = new EventEmitter();

  constructor() {
  }

  getCurrentDateTime(raceDateTime: Date, current_time: number) {
    if (raceDateTime) {
      const currentRaceDateTime = new Date();
      currentRaceDateTime.setTime(raceDateTime.getTime() + current_time);
      return currentRaceDateTime;
    }
    return null;
  }

  isDateValid(date: Date) {
    return !isNaN(date.getTime());
  }

  getPosition(item: Competitor, position: number) {
    let pos = false;
    let pos1 = false;
    if (item.firstRacePos === '9999') {
      item.firstRacePos = 'N/A';
      pos = true;
    } else if (item.firstRacePos === '9998') {
      item.firstRacePos = 'DNF';
      pos = true;
    }

    if (item.twoRacePos === '9999') {
      item.twoRacePos = 'N/A';
      pos1 = true;
    } else if (item.twoRacePos === '9998') {
      item.twoRacePos = 'DNF';
      pos1 = true;
    }

    let num_str = '';

    if (pos || (pos && pos1 && item.twoRacePos)) {
      num_str = ' - ';
    } else {
      num_str = position.toString();
    }
    return { num_str };
  }

  /**
 * generate groups of 4 random characters
 * @example getUniqueId(1) : 607f
 * @example getUniqueId(2) : 95ca-361a-f8a1-1e73
 */
  getUniqueId(parts: number): string {
    const stringArr: string[] = [];
    for (let i = 0; i < parts; i++) {
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

  confirm(confirmation: Confirmation) {
    this.confirmEvent.emit(confirmation);
  }

  // Преобразует Date в строку yyyy-mm-dd с учетом часового пояса
  toISOStringWithTimezone(date: Date): string {
    const timezoneOffset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - timezoneOffset * 60000);
    return localDate.toISOString().substring(0, 10);
  }

  // Обработка изменения адреса (Google Places)
  handleAddressChange(address: Address, profileForm: FormGroup, countries: any[]): void {
    if (address.address_components) {
      let place = address.formatted_address;
      let countryId!: string;
      let countryName!: string;
      let name!: string;
      address.address_components.forEach((addres) => {
        if (addres.types.some((type) => type.includes('country'))) {
          countryId = addres.short_name;
          countryName = addres.long_name;
        }
      });

      if (!countryId) countryId = '';
      const addressString = place.includes(`, ${countryName}`)
        ? place.split(`, ${countryName}`)[0]
        : place;
      const cityData: City = {
        id: address.place_id,
        name: address.name,
        address: addressString,
        gps: {
          latitude: address.geometry.location.lat(),
          longitude: address.geometry.location.lng(),
          description: '',
        },
        countryId,
        utcOffset: address.utc_offset,
      };
      profileForm.controls['cityObject'].setValue(cityData);
      profileForm.controls['city'].setValue(cityData.address);
      const countryByCity = countries.find((country) => country.iso2.toLowerCase() === countryId.toLowerCase());
      if (countryByCity) {
        profileForm.controls['citizenship'].setValue(countryByCity.iso2);
      }
    }
  }
}

